import { s3ProgressConfig } from "../utils/uploadProgress";
import type { ReceivableTemplate, ReceivableTemplateSearchResponse } from "../types/receivableTemplateTypes";
import { api } from "./axiosClient";
import axios from "axios";

export const receivableTemplateApi = {
  searchReceivableTemplate: async (payload: any) => {
    const response = await api.post<ReceivableTemplateSearchResponse>(
      "/receivabletemplate/Search",
      payload,
    );
    return response.data;
  },

  initUpload: async (ids: string[]) => {
    const response = await api.post("/receivabletemplate/initupload", { ids });
    return response.data;
  },

  uploadToS3: async (s3Url: string, file: File) => {
    return await axios.put(s3Url, file, {
      ...s3ProgressConfig(file),
      headers: {
        "Content-Type": file.type,
      },
    });
  },

  uploadMedia: async (receivableTemplateId: string, medias: any[]) => {
    const body = {
      receivableTemplateId,
      medias,
    };

    return await api.post("/receivabletemplate/uploadmedia", body);
  },

  getMediaLink: async (
    ids: string[],
    size: number = 1,
    groupId?: string,
  ): Promise<{
    links: Array<{
      id: string;
      link: string;
    }>;
  }> => {
    const response = await api.post("/receivabletemplate/getmedialink", {
      ids,
      size,
      groupId,
    });

    return response.data;
  },

  createReceivableTemplate: async (data: Partial<ReceivableTemplate>) => {
    const response = await api.post("/receivabletemplate/create", data);

    return response.data;
  },

  updateReceivableTemplate: async (data: Partial<ReceivableTemplate>) => {
    const response = await api.post("/receivabletemplate/edit", data);

    return response.data;
  },

  activateReceivableTemplate: async (id: string) => {
    return await api.post("/receivabletemplate/changeStatus", {
      receivableTemplateId: id,
      isActive: true,
    });
  },

  deActivateReceivableTemplate: async (id: string) => {
    return await api.post("/receivabletemplate/changeStatus", {
      receivableTemplateId: id,
      isActive: false,
    });
  },

  /** Soft delete; the reason is required and kept on the template's audit trail. */
  removeReceivableTemplate: async (id: string, reason: string) => {
    return await api.post("/receivabletemplate/remove", { id, reason });
  },

  activateTemplate: async (id: string) => {
    return await api.post("/receivabletemplate/activate", {
      id,
    });
  },

  deActivateTemplate: async (id: string) => {
    return await api.post("/receivabletemplate/deactivate", {
      id,
    });
  },
};
